import { Routes } from '@angular/router';
import {AiChatComponent} from "./ai-chat.component";
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';

export const aiChatRoutes: Routes = [
    {
        path: 'ai-chat',
        component: AiChatComponent,
        canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
        data: { enterpriseModules: ['AI_CHAT'], enterpriseFeatureLabel: 'AI Chat', permission: app_permissions.ai_chat.view }
    },
];
